import React from "react";

const Carousel = () => {
    const htmlContent = `
    <!doctype html>
    <html lang="ru">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Бесконечная карусель с логами</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body {
            display: flex; justify-content: center; align-items: center;
            height: 100vh; font-family: Arial, sans-serif;
            background: #f0f2f5; overflow: hidden;
          }
          .carousel {
            position: relative; width: 100%; max-width: 720px;
            height: 400px; max-height: 80vh; overflow: hidden;
            border-radius: 16px; box-shadow: 0 10px 40px rgba(0,0,0,0.5);
            cursor: pointer;
          }
          .slides {
            display: flex; width: 100%; height: 100%;
            transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          }
          .slide {
            min-width: 100%; height: 100%; display: flex;
            justify-content: center; align-items: center; color: #fff;
            font-weight: bold; font-size: 2rem; text-shadow: 0 2px 8px rgba(0,0,0,0.4);
            background-size: cover; background-position: center;
            position: relative; flex-shrink: 0; user-select: none;
          }
          .slide::after {
            content: ""; position: absolute; inset: 0;
            background: linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 40%);
          }
          .slide img {
            width: 100%; height: 100%; object-fit: cover;
            position: absolute; inset: 0; pointer-events: none;
          }
          .slide-label {
            position: relative; z-index: 2; padding: 12px 28px;
            background: rgba(0,0,0,0.45); backdrop-filter: blur(6px);
            border-radius: 8px; font-size: 1.1rem; letter-spacing: 1px;
            pointer-events: none;
          }
          .btn {
            position: absolute; top: 50%; transform: translateY(-50%);
            z-index: 10; width: 48px; height: 48px; border: none;
            border-radius: 50%; background: rgba(255,255,255,0.15);
            backdrop-filter: blur(8px); color: #fff; font-size: 1.4rem;
            cursor: pointer; transition: background 0.3s, transform 0.3s;
            display: flex; align-items: center; justify-content: center;
          }
          .btn:hover {
            background: rgba(255,255,255,0.35);
            transform: translateY(-50%) scale(1.12);
          }
          .btn:active {
            transform: translateY(-50%) scale(0.95);
          }
          .btn-prev { left: 14px; }
          .btn-next { right: 14px; }
          .dots {
            position: absolute; bottom: 16px; left: 50%;
            transform: translateX(-50%); z-index: 10;
            display: flex; gap: 10px;
          }
          .dot {
            width: 12px; height: 12px; border-radius: 50%;
            border: 2px solid #fff; background: transparent;
            cursor: pointer; transition: background 0.3s, transform 0.3s;
          }
          .dot.active { background: #fff; transform: scale(1.25); }
          .dot:hover { background: rgba(255,255,255,0.6); }
        </style>
      </head>
      <body>
        <div class="carousel" id="carousel">
          <div class="slides" id="slides"></div>
          <button class="btn btn-prev" id="prevBtn">&#10094;</button>
          <button class="btn btn-next" id="nextBtn">&#10095;</button>
          <div class="dots" id="dots">
            <div class="dot active" data-index="0"></div>
            <div class="dot" data-index="1"></div>
            <div class="dot" data-index="2"></div>
          </div>
        </div>
        <script>
          const slidesContainer = document.getElementById("slides");
          const dots = document.querySelectorAll(".dot");
          const prevBtn = document.getElementById("prevBtn");
          const nextBtn = document.getElementById("nextBtn");
          const carousel = document.getElementById("carousel");
          const slidesData = [
            { img: "https://static-basket-01.wbbasket.ru/vol1/crm-bnrs/bnnrsdmn/image/f8b05347-10eb-48e5-bc60-d527e22204c5.webp", label: "Слайд 1" },
            { img: "https://static-basket-01.wbbasket.ru/vol1/crm-bnrs/bnnrsdmn/image/720x400/799a46ee-90ab-4192-bfb1-d6815a5ede80.webp", label: "Слайд 2" },
            { img: "https://static-basket-01.wbbasket.ru/vol1/crm-bnrs/bnnrsdmn/image/720x400/5f1839d8-fd6d-4655-a761-315b26e93749.webp", label: "Слайд 3" },
          ];
          const TOTAL = slidesData.length;
          const INTERVAL = 3000;
          let position = 1;
          let autoTimer = null;
          let isTransitioning = true;
          let currentRealIndex = 0;

          function createSlides() {
            const lastClone = createSlide(slidesData[TOTAL - 1], "clone-last");
            slidesContainer.appendChild(lastClone);
            slidesData.forEach((data, i) => {
              const slide = createSlide(data, i);
              slide.addEventListener("click", (e) => {
                e.stopPropagation();
                console.log(\`👆 Клик по слайду \${i + 1}: \${data.label}\`);
              });
              slidesContainer.appendChild(slide);
            });
            const firstClone = createSlide(slidesData[0], "clone-first");
            slidesContainer.appendChild(firstClone);
            slidesContainer.style.transition = "none";
            slidesContainer.style.transform = \`translateX(-\${position * 100}%)\`;
          }

          function createSlide(data, identifier) {
            const slide = document.createElement("div");
            slide.className = "slide";
            if (typeof identifier === "number") {
              slide.dataset.index = identifier;
              slide.dataset.label = data.label;
            } else {
              slide.dataset.clone = identifier;
            }
            slide.innerHTML = \`<img src="\${data.img}" alt="\${data.label}"><span class="slide-label">\${data.label}</span>\`;
            return slide;
          }

          function moveTo(pos, instant = false) {
            if (instant) {
              slidesContainer.style.transition = "none";
            } else {
              void slidesContainer.offsetWidth;
              slidesContainer.style.transition = "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
            }
            slidesContainer.style.transform = \`translateX(-\${pos * 100}%)\`;
            position = pos;
          }

          function handleInfiniteScroll() {
            if (position === TOTAL + 1) { moveTo(1, true); return { jumped: true, realIndex: 0 }; }
            if (position === 0) { moveTo(TOTAL, true); return { jumped: true, realIndex: TOTAL - 1 }; }
            return { jumped: false, realIndex: position - 1 };
          }

          function updateDots(realIndex) {
            dots.forEach((d, i) => d.classList.toggle("active", i === realIndex));
            console.log(\`🖼️ Слайд \${realIndex + 1} показан: \${slidesData[realIndex].label}\`);
          }

          function goTo(direction) {
            if (!isTransitioning) return;
            isTransitioning = false;
            moveTo(position + direction);
            const { jumped, realIndex } = handleInfiniteScroll();
            updateDots(realIndex);
            currentRealIndex = realIndex;
            setTimeout(() => { isTransitioning = true; }, 600);
            resetAuto();
          }

          function startAuto() { autoTimer = setTimeout(() => goTo(1), INTERVAL); }
          function resetAuto() { clearTimeout(autoTimer); startAuto(); }

          prevBtn.addEventListener("click", (e) => { e.stopPropagation(); goTo(-1); });
          nextBtn.addEventListener("click", (e) => { e.stopPropagation(); goTo(1); });

          dots.forEach((dot) => {
            dot.addEventListener("click", (e) => {
              e.stopPropagation();
              const targetIndex = +dot.dataset.index;
              if (!isTransitioning) return;
              isTransitioning = false;
              moveTo(targetIndex + 1);
              updateDots(targetIndex);
              currentRealIndex = targetIndex;
              setTimeout(() => { isTransitioning = true; }, 600);
              resetAuto();
            });
          });

          carousel.addEventListener("mouseenter", () => clearTimeout(autoTimer));
          carousel.addEventListener("mouseleave", () => resetAuto());

          let touchStartX = 0;
          carousel.addEventListener("touchstart", (e) => { touchStartX = e.touches[0].clientX; clearTimeout(autoTimer); }, { passive: true });
          carousel.addEventListener("touchend", (e) => {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 40) { goTo(diff > 0 ? 1 : -1); } else { resetAuto(); }
          }, { passive: true });

          carousel.addEventListener("click", (e) => {
            if (!e.target.closest(".btn") && !e.target.closest(".dot")) {
              console.log(\`👆 Клик по области карусели (активен слайд \${currentRealIndex + 1})\`);
            }
          });

          createSlides();
        </script>
      </body>
    </html>
  `;

    return (
        <div>
            <iframe srcDoc={htmlContent} title="Carousel" style={{ width: "100%", height: "400px", border: "none", borderRadius: "16px" }} sandbox="allow-scripts allow-same-origin" />
        </div>
    );
};

export default Carousel;
